export default __webpack_public_path__ + "static/media/151-measuring-1.1fa84f87.png";